/* src/app/admin/client-list/client-list.component.scss */
.client-download {
  padding: 7px 15px;
  min-width: inherit;
  background: transparent;
  border: 1px solid #7d1438;
  color: #7d1438;
  border-radius: 6px;
}
.client-download:hover {
  border: 1px solid black !important;
  cursor: pointer;
}
/*# sourceMappingURL=client-list.component-LC3LH2D3.css.map */
